import React from "react";
import { View, Text, StyleSheet, TouchableOpacity, ActivityIndicator,
	Platform, Dimensions, AsyncStorage, I18nManager } from "react-native";
	
import * as firebase from "firebase";
import * as Font from 'expo-font';
import { color } from "../config/color"
import store from "../config/config.json"

import TopBar from "../widgets/TopBar";
import Main from "../widgets/Main";
import Menu from "../widgets/Menu";
import i18n from 'i18n-js';

import TextField from '@material-ui/core/TextField';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import MainComponent from "../utilities/MainComponent";

import { StylesProvider, ThemeProvider, jssPreset } from "@material-ui/styles";
import { create } from "jss";
import rtl from "jss-rtl";

import AppContext, {AppProvider} from "../utilities/AppContext"

export default class StatusScreen extends MainComponent {	
	
	static path = ''
	
	state = {
		store: {},
		title: "Status",
		topBarData:{title: "Order Look Up", isScrollable: false},
		showCart: false,
		orderCount : 0,
		search: "",
		phone: "",
		//phone: "+9651234567",
		//search: "NIC000012",
		showMenu 		: false,
		showFullMode 	: true,
		showError: false,
		errorMessage: "",
		isLoading: false
	};

 	jss = create({ plugins: [...jssPreset().plugins, rtl()] });
 	theme = createMuiTheme({
		palette: {
		  primary: {
			main: store.primaryColor,
		  },
		}, 
	  });

	static navigationOptions = {
		headerShown: false
	};

	changeState(states){
		if(states.openOrder != undefined && states.openOrder == true)
			this.reviewOrder()
		else
			this.setState(states)
	}

	reviewOrder(){

		if(this.state.deliveryData == undefined || this.state.deliveryData.area == undefined
			 || this.state.deliveryData.area === {} || this.state.deliveryData.area == ''){
			this.props.navigation.navigate('Area', {
				deliveryData: this.state.deliveryData,
				onSelectArea:this.onSelectArea.bind(this)
			});
			return
		}

		if(this.state.deliveryData == undefined || this.state.deliveryData.area == undefined
			|| this.state.deliveryData.timings === {} || this.state.deliveryData.timings == ''){
			this.props.navigation.navigate('Scheduled', {
					timings: this.state.deliveryData.timings,
					onSelectTimings:this.onSelectTimings.bind(this)
			});
		   return
	   }
		
	   this.props.navigation.navigate("Review");
	}

	constructor(props) {
		super(props);

		this.reviewOrder = this.reviewOrder.bind(this)
		this.changeState = this.changeState.bind(this)

		let screenWidth   = window.innerWidth;
		let screenHeight  = window.innerHeight;
		
		this.state.height = screenHeight
		this.state.width = screenWidth

		if(screenWidth < color.screenLimit){
			this.state.showFullMode = false;			
		}else{
			this.state.showFullMode = true;			
		}
	}

	componentDidMount() {	

		Dimensions.addEventListener('change', (e) => {
			const { width, height } = e.window;
			this.setState({height: height, width})
			if(width < color.screenLimit){
				this.setState({showFullMode: false});			
			}else{
				this.setState({showFullMode: true});			
			}
		})

		this.updateCart()
	}

	updateCart = async () => {

		await Font.loadAsync(color.appFonts);

		try {

            var value = await AsyncStorage.getItem(store.storeData)
			if (value == undefined)
				value = {}
			else
			{
				value = JSON.parse(value)			
           	 	this.setState({store: value})
			}
			
        } catch (error) {
            console.log(error)
		}
		
		try {
			var selectedIds = []
			//await AsyncStorage.clear()
			var value = await AsyncStorage.getItem(store.key)
			if (value == undefined)
				value = []
			else
				value = JSON.parse(value)			
			
			if(value.length > 0){
				var totalPrice = 0
				value.map(item => {
					totalPrice += item.price
					item.addons.map(addon => {
						addon.modifiers.map(modifier => {
							totalPrice += modifier.price
						})
					})
					selectedIds[item.itemId] = item.counter
				})

				this.setState({showCart: true, totalPrice: totalPrice, orderCount: value.length, selectedIds: selectedIds})
			}

			var value = await AsyncStorage.getItem(store.delivery)
			if (value == undefined)
				value = {name: ""}
			else
				this.setState({deliveryData: JSON.parse(value)})

		} catch (error) {
			console.log(error)
		}
	}

	updateSearch(){

		if(this.state.search == "" || this.state.isLoading){
			return
		}

		var searchText = this.state.search.toUpperCase();
		searchText = searchText.replace("-", "")

		this.setState({isLoading: true, showError: false})
		firebase.database().ref('/storeOrders/' + store.storeId)
				.orderByChild("orderId")
				.equalTo(searchText)
				.once("value", function(snapshot) 
		{			
			var value = snapshot.val()
			if(value != undefined)
			{
				let orderData = Object.keys(value).map(function(key) {
					value[key].key = key;
					return value[key];
				})

				console.log(orderData)

				if(orderData.length > 0 && orderData[0].userData.phone == this.state.phone)
				{					
					this.context.setReceipt({
						data: orderData[0],
						showReceipt: false
					})
					this.setState({isLoading: false, showError: false})
					this.props.navigation.navigate('receipt')							
				}
				else{
					this.setState({isLoading: false, showError: true, errorMessage: "Order with these details not found"})
				}
			}
			else{
				this.setState({isLoading: false, showError: true, errorMessage: "Order with these details not found"})
			}
		}
		.bind(this), function(error) { 
			this.setState({isLoading: false, showError: false, errorMessage: "An unkown error has occurred"})
		});
		
	}

	openMenu(){
		this.setState({showMenu: true});
	}

	handleChange = name => event => {
		this.setState({ [name]: event.target.value, showError : false });
	};

	/****
	 * 
	 * 
	 * 
	 */
	
	renderDetails(marginTop){

		return (
			<View style={{flex:1, backgroundColor: color.bigSeparator}}>
				<View style={{marginTop: marginTop}}></View>

				<View style={{backgroundColor: 'white', height: 189}}>
					<View style={{height: 8, backgroundColor:color.bigSeparator, justifyContent: "center"}}/>
					<Text style={{ fontFamily: 'main-regular', color: color.detailsColor, marginLeft: 15, marginRight: 15, marginTop: 15, fontSize: 15}}>{i18n.t("orderSMS")}</Text>

					<View style={{ marginBottom: 15, marginLeft:15, marginRight: 15, marginTop:15}}>

						<StylesProvider jss={this.jss}>
							<ThemeProvider theme={this.theme}>
							
							{ this.state.showError  && (
								<TextField 
									error
									id="standard-basic" 
									label={i18n.t("orderCode")}
									color="secondary"
									value={this.state.search}
									onChange={this.handleChange('search')}
									helperText={this.state.showError ? "Your code is invalid" : ""}
								/>
							)}

							{ !this.state.showError  && (
								
								<TextField 
									style={{textAlign: "left"}}								
									id="standard-basic" 
									label={i18n.t("orderCode")}
									value={this.state.search}
									onChange={this.handleChange('search')}
									helperText={this.state.showError ? "Your code is invalid" : ""}
									/>
							)}

							<TextField 
									style={{textAlign: "left", marginTop: 5}}								
									id="standard-basic" 
									label={i18n.t("phone")}
									color="secondary"
									value={this.state.phone}
									onChange={this.handleChange('phone')}
								/>

							</ThemeProvider>
						</StylesProvider>
						
					</View>
					
				</View>
				
				<View style={{height: 64, backgroundColor:"white", justifyContent: "center", marginTop: "auto"}}>											
						<TouchableOpacity style={{marginLeft: 10, marginRight: 10, marginBottom: 8, marginTop: "auto", height:48, justifyContent: "center"}}
										onPress={() => { this.updateSearch() }}
								>
							<View style={{flexDirection: "row", justifyContent: "center", alignItems: "center", flex:1, borderRadius: store.buttonCorner, backgroundColor:this.state.store.primaryColor}}>
								{ this.state.isLoading  && (
									<ActivityIndicator style={{marginRight: 5}} size="small" color='white' /> 
								)}
								{ !this.state.isLoading  && (
									<Text style={{ fontFamily: 'main-bold',position: "absolute", marginLeft: "auto", marginRight: "auto", color:'#FFF', fontSize:14}}>{i18n.t("lookUpOrder")}</Text>
								)}
							</View>
						</TouchableOpacity>
				</View>

			</View>
		)
	}
	
	render() {
		var that = this
		if(I18nManager.isRTL){
			this.theme = createMuiTheme({
				direction : "rtl",
				palette: {
				  primary: {
					main: store.primaryColor,
				  },
				}, 
			  });
		}else{
			this.theme = createMuiTheme({
				palette: {
				  primary: {
					main: store.primaryColor,
				  },
				}, 
			  });
		}

		return (
			<AppContext.Consumer>
			{ (context) => (
				<View style={styles.container} ref={(ref) => { 
					this.context = context; 					
				}}>
					
				{this.state.showFullMode && (										
					
					<View style={styles.webContainer}>						
						
						<View style={{height: this.state.height, width: this.state.width * .33}}>
	                        {this.renderDetails(50)}
							<TopBar {...this.state} changeState={this.changeState} />
						</View>	

						<Main {...this.state} changeMenu={this.changeMenu} />

					</View>					
				)}
				
				{!this.state.showFullMode && !this.state.showMenu && (
					<View style={styles.container}>						
												
						<View style={{height: this.state.height}}>
	                        {that.renderDetails(50)}
						</View>	
						<TopBar {...this.state} changeState={this.changeState} reviewOrder={this.reviewOrder} />

					</View>
				)}

				{!this.state.showFullMode && this.state.showMenu && (					
					<View style={styles.container}>						

						<Menu {...this.state} changeState={this.changeState} />
						
					</View>
				)}	
				
			</View>
			)}	
		</AppContext.Consumer>
	  );
	}
}

const styles = StyleSheet.create({
	container: {
		flex: 1,
		backgroundColor: 'white'
	},
	webContainer: {
		flex: 1,
		flexDirection: "row",
	}
});
